import { SECTIONS_SELECTOR_HEIGHT } from "@/pages/HomePage/components/ProductList";

import type { SectionListItem } from "./types";

export const applySectionColors = (
  sections: SectionListItem[],
  colors: string[],
): SectionListItem[] => {
  if (colors.length === 0) return sections;

  return sections.map((s, idx) => ({
    ...s,
    bgColor: colors[idx % colors.length],
  }));
};

export const scrollToSection = (
  sectionId: number,
  compensation?: number,
): void => {
  if (typeof sectionId !== "number" || !Number.isFinite(sectionId)) {
    return;
  }

  const wrapper = document.querySelector(`#section-${sectionId}`);

  if (wrapper) {
    const bodyRect = document.body.getBoundingClientRect();
    const wrapperRect = wrapper.getBoundingClientRect();
    const offset = wrapperRect.top - bodyRect.top;
    const isTargetAboveCurrentScroll = window.scrollY > offset;
    const directionCompensation = isTargetAboveCurrentScroll
      ? SECTIONS_SELECTOR_HEIGHT + 48
      : SECTIONS_SELECTOR_HEIGHT;

    window.scrollTo({
      top: Number(offset) - directionCompensation + (compensation || 0),
      behavior: "smooth",
    });
  }
};
